import { Button } from "@mui/material";
import React, { Fragment, useContext, useState } from "react";
import { FiPlus } from "react-icons/fi";
import SwitchField from "../../../components/editable/EditableField/fields/SwitchField";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import TabbedView from "../../../components/lists/TabbedView/TabbedView";
import TabbedViewPage from "../../../components/lists/TabbedView/TabbedViewPage";
import { IListDevicesRequest, Device, api, IListActivationsRequest, IListActivationsResponse, DeviceDeactivateHistory, IListDeactivationsRequest } from "../../../logic/api";
import flex from "../../../styles/flex";
import { SessionContext } from "../../../utility/useSession";
import DashPage from "../../dash/DashPage";
import NotFoundPage from "../../error/NotFoundPage";
import { DeviceActivationDialog } from "../device_activation/DeviceActivationDialog";
import DeviceActivationListItem from "./components/listItems/DeviceActivationListItem";
import DeviceDeActivationListItem from "./components/listItems/DeviceDeActivationListItem";
import DeviceListItem from "./components/listItems/DeviceListItem";


import styles from "./styles";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import ConfirmationDialog from "../../../components/notifications/confirmationDialog/ConfirmationDialog";
import { useTranslation } from "react-i18next";

const DevicesPage = () => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  if (session.current.site == null) {
    return <Fragment></Fragment>;
  }
  if (session.current.site.preferences.enable_device_manager != true) {
    return <NotFoundPage title={t("notFoundPage.notAvailable")} message={t("notFoundPage.featureNotEnabled")}></NotFoundPage>
  }
  const [listDeviceParams, setListDeviceParams] = useState<IListDevicesRequest>({
    includeInactive: false,
    paging: {
      offset: 0,
      limit: 0,
    }
  });

  const [listActivationsParams] = useState<IListActivationsRequest>({
    paging: {
      offset: 0,
      limit: 0,
    }
  });

  const [showDeviceActivationDialog, setShowDeviceActiviationDialog] = useState(false);

  const deActivate = api.hooks.device.deActivate();
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);

  const [showDeActivationConfirm, setShowDeActivationConfirm] = useState(false);

  const deActivateDevice = async () => {
    if (selectedDevice == null) return;
    deActivate.send(session.current.context, {
      carParkId: (session.current.site?.home.id ?? 1).toString(),
      device: selectedDevice,
      userId: session.current.site?.user?.id ?? 0,
    }, () => {
      setListDeviceParams({ ...listDeviceParams });
    });
  }
  return (
    <DashPage>
      <DeviceActivationDialog show={showDeviceActivationDialog} onCompleted={(didActivateNewDevice) => {
        setShowDeviceActiviationDialog(false);
        if (didActivateNewDevice) {
          setListDeviceParams({ ...listDeviceParams });
        }
      }}></DeviceActivationDialog>

      <ErrorDialog err={deActivate.err}></ErrorDialog>
      <ProgressDialog status={deActivate.status}></ProgressDialog>

      <ConfirmationDialog
        title="Confirm delete"
        message={`Are you sure you want to de-activate the device: '${selectedDevice?.name ?? ""}'?`}
        show={showDeActivationConfirm}
        onClose={(confirm) => {
          setShowDeActivationConfirm(false);
          if (confirm == true) {
            deActivateDevice();
          }
        }}
      ></ConfirmationDialog>

      <div style={{ padding: 20 }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ padding: 20, marginBottom: 50 }}>
            <div><span style={styles.title}>{t("mobile.deviceManager")}</span></div>
            <div><span style={styles.message}>{t("mobile.setupMonitorDevices")}</span></div>
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ width: "100%", maxWidth: 1200, display: "inline-block" }}>

            <TabbedView>
              <TabbedViewPage title="Devices">
                <div style={{ padding: 10, textAlign: "right" }}>
                  <div style={flex.flexRows}>
                    <Fragment>
                      <div style={flex.flexAuto}>
                        <SwitchField
                          onChange={(includeInactive) => {
                            setListDeviceParams({
                              ...listDeviceParams,
                              includeInactive: includeInactive,
                            });
                          }}
                          value={listDeviceParams.includeInactive}
                        />
                      </div>
                      <div style={flex.flexAuto}>
                        <div
                          style={{ textAlign: "right", paddingTop: 10, color: "grey" }}
                        >
                          {t("mobile.includeDisabled")}
                        </div>
                      </div>
                    </Fragment>

                    <div style={flex.flexFill}></div>

                    <div style={flex.flexAuto}>
                      <Button
                        style={{ marginLeft: 10 }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          setShowDeviceActiviationDialog(true);
                        }}
                      >
                        <FiPlus style={{ marginRight: 10 }} />
                        {t("mobile.setupNewDevice")}
                      </Button>
                    </div>

                  </div>
                </div>

                <PagedDataView<IListDevicesRequest, Device>
                  apiHook={api.hooks.deviceManager.listDevices}
                  parameters={listDeviceParams}
                  renderItem={(item) => {
                    return <DeviceListItem
                      key={item.id}
                      device={item}
                      onSelect={() => {
                        setSelectedDevice(item);
                        setShowDeActivationConfirm(true);
                      }}
                    />
                  }}
                >
                  <div style={{ padding: 20, backgroundColor: "#eee" }}>
                    {t("mobile.noDevicesFound")}
                  </div>
                </PagedDataView>
              </TabbedViewPage>
              <TabbedViewPage title={t("mobile.activationHistory")}>

                <PagedDataView<IListActivationsRequest, IListActivationsResponse>
                  apiHook={api.hooks.deviceManager.listActivations}
                  parameters={listActivationsParams}
                  renderItem={(item) => {
                    return <DeviceActivationListItem
                      key={item.activation.id}
                      activation={item}
                    />
                  }}
                >
                  <div style={{ padding: 20, backgroundColor: "#eee" }}>
                    {t("mobile.noActivationsFound")}
                  </div>
                </PagedDataView>
              </TabbedViewPage>
              <TabbedViewPage title={t("mobile.deactivationHistory")}>

                <PagedDataView<IListDeactivationsRequest, DeviceDeactivateHistory>
                  apiHook={api.hooks.deviceManager.listDeactivations}
                  parameters={listActivationsParams}
                  renderItem={(item) => {
                    return <DeviceDeActivationListItem
                      key={item.id}
                      history={item}
                    />
                  }}
                >
                  <div style={{ padding: 20, backgroundColor: "#eee" }}>
                    {t("mobile.noDeactivationsFound")}
                  </div>
                </PagedDataView>
              </TabbedViewPage>
            </TabbedView>

          </div>
        </div>
      </div>

    </DashPage >

  );
};

export default DevicesPage;
